



















import {Component, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Editor from '@tinymce/tinymce-vue';

export class rules {
    uyelik_rule : String = "";
    satin_alma_rule : String = "";
    mesafeli_on_satis_rule : String = "";
}
@Component({
    components: {
        EForm,Number,TextField,Editor
    }
})
export default class Rules extends  Vue{
    action : string = "config/sozlesmeler";
    data : rules = new rules();
    async get(){
        let response = await this.$http.get(this.action);
        this.data = response.data;
    }
    created(){
        this.get();
    }
};
